export default "__VITE_ASSET__rX53UJHc__"